export default __webpack_public_path__ + "static/media/rouded-text.efb80383.svg";